export enum OperatorType {
  EQUAL = "=",
  NOT_EQUAL = "!=",
  LESS_THAN = "<",
  GREATER_THAN = ">",
  LESS_THAN_EQUAL = "<=",
  GREATER_THAN_EQUAL = ">=",
  IN = "in",
  NOT_IN = "not_in",
  IS_NULL = "is_null",
  IS_NOT_NULL = "is_not_null",
}

export const OPERATOR_SYMBOLS: Record<OperatorType, string> = {
  [OperatorType.EQUAL]: "=",
  [OperatorType.NOT_EQUAL]: "≠",
  [OperatorType.LESS_THAN]: "<",
  [OperatorType.GREATER_THAN]: ">",
  [OperatorType.LESS_THAN_EQUAL]: "≤",
  [OperatorType.GREATER_THAN_EQUAL]: "≥",
  [OperatorType.IN]: "in",
  [OperatorType.NOT_IN]: "not in",
  [OperatorType.IS_NULL]: "is null",
  [OperatorType.IS_NOT_NULL]: "is not null",
};

const UNARY_OPERATORS = [OperatorType.IS_NULL, OperatorType.IS_NOT_NULL];
const TAG_INPUT_OPERATORS = [OperatorType.IN, OperatorType.NOT_IN];

export const isUnaryOperator = (operator: string): boolean =>
  UNARY_OPERATORS.includes(operator as OperatorType);

export const shouldUseTagInput = (operator: OperatorType | string): boolean =>
  TAG_INPUT_OPERATORS.includes(operator as OperatorType);

export const getRightInputPlaceholder = (operator: string): string => {
  switch (operator as OperatorType) {
    case OperatorType.IN:
    case OperatorType.NOT_IN:
      return "value1, value2, value3";
    default:
      return "Enter a value";
  }
};
